export enum InvestmentStatusKey {
  SIGNED = 'signed',
  PAYMENT_PENDING = 'payment_pending',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
  VALIDATED = 'validated',
}

export enum WithdrawalStatusKey {
  PENDING = 'pending',
  VALIDATED = 'validated',
  REFUSED = 'refused',
}
